export const isInt = (n?: number | null, toFixed = 2) => {
  if (!n) return 0;
  if (n % 1 === 0) return n;
  return Number(n.toFixed(toFixed));
};
